import _ from 'underscore';
import $ from 'jquery';

import {
  CHANGE_VIDEOS_SORT,
  RECEIVE_CONTENT_ITEMS,
} from 'common/actions';

const defaultState = {
  contentItems: [],
  isComplete: false,
};

function videos(state = defaultState, action) {
  const newState = $.extend(true, {}, state);
  switch (action.type) {
  case CHANGE_VIDEOS_SORT:
    newState.sort = action.payload.sort;
    break;
  case RECEIVE_CONTENT_ITEMS:
    newState.isComplete = action.payload.isComplete;
    newState.contentItems = newState.contentItems.concat(action.payload.contentItems);
    newState.contentItems = _.uniq(newState.contentItems, true, c => c.id);
    break;
  default:
    return state;
  }
  return newState;
}

export default videos;
